<template>
  <div>
    <div class="container mx-auto flex flex-col laptop:flex-row pt-12 lg:pt-32">
      <div class="laptop:w-6/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-5/6">
        <MARSTitle h1><div v-html="$t('roadmap.title')" /></MARSTitle>
      </div>
      <div class="laptop:w-5/12 p-5 md:p-0 laptop:pl-0 laptop:mr-24 md:mx-8 md:w-5/6 mt-8 laptop:mt-4 laptop:mb-0">
        <h2 class="" v-html="$t('roadmap.subtitle')" />
        <p class="text-standard laptop:text-slg md:text-base leading-7 py-8" v-html="$t('roadmap.title-text')" />
      </div>
    </div>

    <!-- ROADMAP -->
    <road-map />
  </div>
</template>

<script lang="ts">
import MARSTitle from '@/components/MARSTitle.vue'
import RoadMap from '@/components/RoadMap.vue'

export default defineNuxtComponent({
  components: { MARSTitle, RoadMap }, // SubTitle
  data() {
    return {
    }
  },
  computed: {
  }
})
</script>

<style scoped>
input[type=radio] {
  width: 1.625rem;
  min-width: 1.625rem;
  height: 1.625rem;
  border-radius: 100%;
  border: 1px solid white;
  appearance: none;
}

input[type=radio]:checked {
  background: radial-gradient(var(--color-highlight) 45%, rgba(255, 0, 0, 0) 51%);
}

</style>
